import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useFetch } from "../api";
import { Alerts, Badge, EmptyRow, Field, Loading, Page, Pager, SignedAmount, Tabs, UserLink } from "../components/ui";
import { label, PAGE_SIZE, qs, setQuery, text, when } from "../format";

export default function Earnings() {
  const [params, setParams] = useSearchParams();
  const page = Math.max(1, Number(params.get("page")) || 1);
  const type = params.get("type") || "";
  const userId = params.get("userId") || "";
  const [draft, setDraft] = useState(userId);
  const list = useFetch("/earnings" + qs({ page, limit: PAGE_SIZE, type, userId }));
  const rows = Array.isArray(list.data?.data) ? list.data.data : [];

  useEffect(() => setDraft(userId), [userId]);

  return (
    <Page title="Earnings" text="Daily earnings and commissions are credited to the member's single wallet. Direct commission is a percent of a direct referral's first package and is paid once, immediately. Level percents are paid with the nightly ROI. Level 1 is the direct sponsor and Level 5 is the fifth upline. A level pays only after the sponsor has that many direct package buyers. A blocked sponsor is skipped. Daily ROI is credited at 12:00 AM IST, and that night's level commission uses the same amount. Failed credits stay on ROI failures.">
      <Alerts error={list.error} />
      <form className="toolbar" onSubmit={(event) => {
        event.preventDefault();
        setQuery(params, setParams, { userId: draft.trim(), page: "" });
      }}>
        <Field label="Member id" error={list.errors.userId}>
          <input value={draft} onChange={(event) => setDraft(event.target.value)} />
        </Field>
        <button className="btn small">Filter</button>
        {userId ? (
          <button type="button" className="btn ghost small" onClick={() => setQuery(params, setParams, { userId: "", page: "" })}>Clear</button>
        ) : null}
      </form>
      <Tabs
        value={type}
        onChange={(value) => setQuery(params, setParams, { type: value, page: "" })}
        options={[
          { value: "", label: "All" },
          { value: "daily_earning", label: "Daily earning" },
          { value: "direct_commission", label: "Direct commission" },
          { value: "level_commission", label: "Level commission" },
        ]}
      />
      {list.loading ? <Loading /> : (
        <div className="table-wrap">
          <table className="wide">
            <thead>
              <tr>
                <th>Member</th><th>Type</th><th>Direction</th><th className="num">Amount</th><th>Note</th><th>Time</th>
              </tr>
            </thead>
            <tbody>
              {rows.length ? rows.map((row) => (
                <tr key={row.id}>
                  <td><UserLink user={row.user} userId={row.userId} /></td>
                  <td>{label(row.type)}</td>
                  <td><Badge value={row.direction} /></td>
                  <SignedAmount value={row.amount} direction={row.direction} />
                  <td>{text(row.note)}</td>
                  <td>{when(row.createdAt)}</td>
                </tr>
              )) : <EmptyRow cols={6} text="No earnings" />}
            </tbody>
          </table>
        </div>
      )}
      {list.data ? (
        <Pager page={page} limit={PAGE_SIZE} total={list.data.total} onPage={(next) => setQuery(params, setParams, { page: next <= 1 ? "" : next })} />
      ) : null}
    </Page>
  );
}
